<template>
  <div class="user-import">
    <h2 class="d-flex justify-content-between">
      {{ $t('message.import_users') }}
      <span>
        <a href="../static/vitamins_usertemplate.csv" class="p-0 btn button-link">
        <i class="fal fa-file-spreadsheet"></i>
        {{ $t('message.download_template') }}
      </a>
       <button @click.prevent="downloadUsers($event)" class="ml-3 p-0 btn button-link">
        <i class="fal fa-file-download"></i>
        {{ $t('message.download_users') }}
      </button>
     </span>
    </h2>
    <div class="row">
      <form v-if="!showPostProcess" class="col-md-12 mb-3">
        <div class="form-row mb-2">
          <div class="col-md-12">
            <label class="d-block" for="userfile">
              <input id="userfile" name="userfile" @input="resetFileInput" @change="readFile($event)" type="file"
                     class="d-none mb-0 form-control styled-input">
              <span class="d-block cursor-pointer form-control styled-input">{{ computedFilename }}</span>
            </label>
          </div>
        </div>
      </form>
      <div class="results col-md-12">
        <div class="row">
          <div class="col-md-12 import-preview preview position-relative invalid mb-5" v-if="invalidRows.length">
            <h3 class="mb-3">{{ $t('message.x_invalid_rows', {amt: invalidRows.length}) }}</h3>
            <ul class="list-style-none small text-danger m-0 p-0 import_error_field_list">
              <li class="p-0 mb-1" v-for="error in errorFields">
                {{ error }}
              </li>
            </ul>
            <table class="no-p mt-0 table table-striped">
              <thead>
              <tr>
                <th v-for="column in columns">{{ $t('message.' + column) }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="record in invalidRows">
                <td v-for="(column,key) in record">

                  <template v-if="
                    key !== 'fullname'
                    && key !== 'username'
                    && key !== 'password'
                    && key !== 'invalidFields'

                    ">
                    <span :class="record.invalidFields.includes(key) ? 'text-danger' : ''">{{ column }}</span>
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 ready" v-if="results">
            <div class="importdone" v-if="showPostProcess">
              <p class="small">{{ $t('message.x_records_processed', {amt: processed}) }}</p>
              <p class="small">{{ $t('message.x_users_imported_successfully', {amt: successRecords}) }}</p>
              <p class="small">{{ $t('message.x_users_could_not_be_imported', {amt: errorRecords}) }}</p>
              <div class="errors-import" v-if="errors.length">
                <h4>{{ $t('message.the_following_errors_occurred') }}</h4>
                <div class="error" v-for="error in orderedErrors">
                  {{ $t('message.row') }} {{ error.row }} &ndash;
                  <span v-for="msg in error.error.response.data.data[0].messages">
                  <span class="field" v-if="msg.field">{{ error.record[msg.field] }}:</span> {{ msg.message }}
                </span>
                </div>
              </div>
              <div class="actions mt-5 text-center">
                <button class="button btn btn-primary" @click.prevent="closePostProcess">{{ $t('message.close') }}
                </button>
              </div>
            </div>
            <div class="import-preview preview position-relative" v-if="firstresults.length">
              <h3 class="mb-3">{{ $t('message.first_x_records', {amt: firstresults.length}) }}</h3>
              <table class="no-p mt-0 table table-striped">
                <thead>
                <tr>
                  <th v-for="column in columns">{{ $t('message.' + column) }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in firstresults">
                  <td v-for="(column,key) in record">
                    <template v-if="localizedFields.includes(key) && column">
                      {{ $t('message.' + column) }}
                    </template>
                    <template v-if="key === 'gender' && column">
                      {{ localizeGender(column) }}
                    </template>

                    <template v-else-if="
                    key !== 'fullname'
                    && key !== 'username'
                    && key !== 'password'
                    && key !== 'employmentstart'
                    && key !== 'employmentend'
                    && key !== 'birthdate'
                    && key !== 'country'
                    && key !== 'invalidFields'
                    && key !== 'rowIndex'
                    ">
                      {{ column }}
                    </template>
                    <template v-else-if="key === 'employmentstart' || key === 'employmentend' || key === 'birthdate'">
                      {{ formatDate(column) }}
                    </template>

                    <template v-else-if="key === 'country' && column">
                      {{ $t('message.country_' + column) }}
                    </template>

                  </td>
                </tr>
                </tbody>
              </table>
              <transition name="loadfade">
                <div class="d-flex align-items-center justify-content-center loadingscreen position-absolute"
                     v-if="processing">
                  <div class="loadingbar d-flex align-items-center justify-content-center position-relative">
                    <div class="complete-pct text-white position-absolute">{{ pctComplete }}%</div>
                    <div :class="parseInt(pctComplete) >= parseInt((pct*10)) ? 'done' : 'not-done'"
                         class="loading-block"
                         v-for="pct in 10">
                    </div>
                  </div>
                </div>
              </transition>
            </div>

            <div class="actions mt-5">
              <button v-if="showImportButton" @click.prevent="handleImport($event)" type="button"
                      class="w-100 btn btn-primary">
                {{ $t('message.import_users') }}
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import store from "../../store/store";
import moment from 'moment';
import _ from 'lodash';

export default {
  data() {
    return {
      localizedFields: [
        'maritalstatus',
        'degreelevel',
        'modeoftransport',
      ],
      countries: store.getters.getCountries,
      filename: '',
      array: [],
      reader: new FileReader(),
      results: [],
      currentUser: store.getters.getUser,
      errors: [],
      successRecords: 0,
      errorRecords: 0,
      showPostProcess: false,
      showErrors: false,
      invalidRows: [],
      processing: false,
      processed: 0,
      columns: [
        'lastname',
        'firstname',
        'email',
        'gender',
        'birthdate',
        'maritalstatus',
        'Street',
        'Number',
        'Bus',
        'zipcode',
        'city',
        'stateprovince',
        'country',
        'jobtitle',
        'seniority',
        'employmentstart',
        'employmentend',
        'terminationreason',
        'degreelevel',
        'modeoftransport',
      ],
    }
  },
  computed: {
    errorFields() {
      let errors = {};
      let errorMessages = {
        lastname: this.$t('') + ' ' + this.$t('message.cannot_be_empty'),
        firstname: this.$t('') + ' ' + this.$t('message.cannot_be_empty'),
        email: this.$t('') + ' ' + this.$t('message.cannot_be_empty'),
        birthdate: this.$t('message.must_be_dmyyyy_or_iso'),
        employmentstart: this.$t('message.must_be_dmyyyy_or_iso'),
        employmentend: this.$t('message.must_be_dmyyyy_or_iso'),
        gender: this.$t('message.field_value_restrictions', {values: ['m', 'f', 'x'].join(', ')}),
        degreelevel: this.$t('message.field_value_restrictions', {values: ['primary', 'secondary', 'bachelor', 'master', 'doctorate'].join(', ')}),
        modeoftransport: this.$t('message.field_value_restrictions', {values: ['car', 'bike', 'foot', 'public', 'other'].join(', ')}),
        maritalstatus: this.$t('message.field_value_restrictions', {values: ['notmarried', 'married', 'divorced', 'widowed'].join(', ')}),
        country: this.$t('message.invalid_country'),
      };
      this.invalidRows.forEach(invalidUser => {
        invalidUser.invalidFields.forEach(field => {
          errors[field] = '[' + this.$t('message.' + field) + ']: ' + errorMessages[field]
        })
      });
      return errors;
    },
    computedFilename() {
      return this.filename ? this.filename : this.$t('message.click_to_add_csv')
    },
    showImportButton() {
      let show = false;
      if (this.results.length) {
        show = true;
      }
      return show;
    },
    orderedErrors() {
      return _.orderBy(this.errors, 'row')
    },
    firstresults() {
      return this.results.slice(0, 10)
    },
    pctComplete() {
      return this.truncate((this.processed / this.results.length) * 100, 0)
    }
  },
  created() {
    this.reader.onload = (e) => {
      this.parseFile(e)
    }
  },
  methods: {
    async downloadUsers(e) {
      e.target.classList.add('loading')
      const userRequest = await this.axios.get('/users?_limit=-1')
      const allUsers = userRequest.data
      const csvData = []
      allUsers.forEach(user => {
        csvData.push({
          lastname: user.lastname,
          firstname: user.firstname,
          email: user.email,
          gender: user.gender,
          birthdate: user.birthdate,
          maritalstatus: user.maritalstatus,
          Street: user.Street,
          Number: user.Number,
          Bus: user.Bus,
          zipcode: user.zipcode,
          city: user.city,
          stateprovince: user.stateprovince,
          country: user.country,
          jobtitle: user.jobtitle,
          seniority: user.seniority,
          employmentstart: user.employmentstart,
          employmentend: user.employmentend,
          terminationreason: user.terminationreason,
          degreelevel: user.degreelevel,
          modeoftransport: user.modeoftransport,
        })
      })

      this.downloadCsv(csvData, moment().format('YYYY-MM-DD') + '_user_export');
      this.loadingSuccess(e.target)
    },
    localizeGender(g) {
      let title = ''
      switch (g) {
        case 'm':
          title = this.$t('message.male');
          break;
        case 'f':
          title = this.$t('message.female');
          break;
        case 'x':
          title = this.$t('message.other');
          break;
        default:
          break;
      }
      return title
    },
    closePostProcess() {
      this.results = [];
      this.errors = [];
      this.successRecords = 0;
      this.errorRecords = 0;
      this.showPostProcess = false;
      this.showErrors = false;
      this.invalidRows = [];
      this.processing = false;
      this.processed = 0;
    },
    randomPassword(length = 12) {
      const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
      let pwa = [];
      for (let i = 0; i < length; i++) {
        let char = chars.charAt(Math.round(Math.random() * (chars.length - 1)));
        pwa.push(char);
      }
      let pws = pwa.join('');
      return pws;
    },
    async handleImport(e) {
      let el = e.target;
      el.classList.add('loading');
      const importing = await this.importValidUsers();
      // console.log('imported')
      this.loadingSuccess(el);
      this.showPostProcess = true;
      this.results = []
      this.invalidRows = []
    },
    importValidUsers() {
      this.processing = true;
      this.processed = 0;
      this.successRecords = 0;
      this.errorRecords = 0;
      //todo: GET all users and loop over results instead of doing GET per user
      // console.log('starting map')
      let promises = this.results.map(async (result, resultIndex) => {
        const foundUser = await this.axios.get('/users?email=' + result.email + '&_limit=1')
        // console.log('get user')
        const request = async () => {
          return foundUser.data.length
            ? await this.axios.put('/users/' + foundUser.data[0].id, result)
            : await this.axios.post('/users', result);
        }

        try {
          const r = await request()
          // console.log('post or put user')
          this.processed++;
          this.successRecords++;
          return r;
        } catch (err) {
          this.processed++;
          this.errorRecords++;
          this.errors.push({
            row: result.rowIndex,
            error: err,
            record: result
          })
        }

        // const request = foundUser.data.length ? await this.axios.put('/users/' + foundUser.data[0].id, result) : await this.axios.post('/users', result);
        // return request
        //   .then(r => {
        //     this.processed++;
        //     this.successRecords++;
        //   })
        //   .catch(r => {
        //     this.processed++;
        //     this.errorRecords++;
        //     this.errors.push({
        //       row: result.rowIndex,
        //       error: r,
        //       record: result
        //     })
        //   });
      });
      // console.log('mapped')
      return Promise.all(promises)
    },


    validateUser(user) {

      let invalidFields = [];
      let valid = true;

      let requiredFields = [
        'email',
        'firstname',
        'lastname',
      ];

      let dateFields = [
        'birthdate',
        'employmentstart',
        'employmentend',
      ];

      requiredFields.forEach(field => {
        if (!user[field]) {
          valid = false;
          invalidFields.push(field)
          user[field] = this.$t('message.$ERR_REQ')
        }
      });

      dateFields.forEach(field => {
        if (user[field]) {
          let m = moment(user[field]);
          if (m.isValid()) {
          } else if (moment(user[field], 'D/M/YYYY').isValid()) {
          } else {
            valid = false;
            invalidFields.push(field);
            user[field] = this.$t('message.$ERR_INVALID')
          }
        }
      });

      if (user['gender']) {
        if (
          user['gender'] === 'm' ||
          user['gender'] === 'f' ||
          user['gender'] === 'x') {
        } else {
          valid = false;
          invalidFields.push('gender');
          user['gender'] = this.$t('message.$ERR_INVALID') + ' [' + user['gender'] + ']'
        }
      }

      if (user['degreelevel']) {
        if (
          user['degreelevel'] === 'primary' ||
          user['degreelevel'] === 'secondary' ||
          user['degreelevel'] === 'bachelor' ||
          user['degreelevel'] === 'master' ||
          user['degreelevel'] === 'doctorate') {
        } else {
          valid = false;
          invalidFields.push('degreelevel');
          user['degreelevel'] = this.$t('message.$ERR_INVALID') + ' [' + user['degreelevel'] + ']'
        }
      }

      if (user['modeoftransport'] && user['modeoftransport'] !== ' ') {
       // console.log('transport', user['modeoftransport'])
       // console.log('transport', JSON.stringify(user['modeoftransport']))
        if (
          user['modeoftransport'] === 'car' ||
          user['modeoftransport'] === 'bike' ||
          user['modeoftransport'] === 'foot' ||
          user['modeoftransport'] === 'public' ||
          user['modeoftransport'] === 'other') {
        } else {
          valid = false;
          invalidFields.push('modeoftransport');
          user['modeoftransport'] = this.$t('message.$ERR_INVALID') + ' [' + user['modeoftransport'] + ']'
        }
      }

      if (user['maritalstatus']) {
        if (
          user['maritalstatus'] === 'notmarried' ||
          user['maritalstatus'] === 'married' ||
          user['maritalstatus'] === 'divorced' ||
          user['maritalstatus'] === 'widowed') {
        } else {
          valid = false;
          invalidFields.push('maritalstatus');
          user['maritalstatus'] = this.$t('message.$ERR_INVALID') + ' [' + user['maritalstatus'] + ']'
        }
      }

      if (user['country']) {
        // console.log('countries',countries)
        if (!this.countries.includes(user['country'])) {
          valid = false;
          invalidFields.push('country');
          user['country'] = this.$t('message.$ERR_INVALID') + ' [' + user['country'] + ']'
        }
      }

      user.invalidFields = invalidFields;

      return {valid: valid, user: user};
    },
    parseFile(e) {
      this.closePostProcess();
      const rows = e.target.result.split("\n");
      let users = [];
      this.results = [];
      let headerColumnLength = 0;

      rows.forEach((row, rowIndex) => {//iterate over CSV rows
        let empty = true;
        let splitRow = row.split(";");
        this.columns.forEach((column, columnIndex) => {
          //match expected columns to found columns and transform to workable data 'splitRow'
          if (splitRow[columnIndex] && !this.isEmptyOrSpaces(splitRow[columnIndex]) && splitRow[columnIndex] !== '\r') {
            splitRow[columnIndex] = splitRow[columnIndex].split('\r').join('');
            empty = false
          }
        });

        if (!empty) {
          //check if row is empty
          if (rowIndex === 0) {
            //count amount of columns
            headerColumnLength = splitRow.length
          }
          if (rowIndex > 0) {
            //skip the header
            //todo match header to this.columns, now is assumed to be identical and in same order
            let user = {};
            this.columns.forEach((column, columnIndex) => {
              user[column] = splitRow[columnIndex].trim().replace('\r', '').replace('"', '')
              //remove spaces, line breaks and quotes
            });
            user['gender'] = user['gender'].toLowerCase();
            user['degreelevel'] = user['degreelevel'].toLowerCase();
            user['modeoftransport'] = user['modeoftransport'].toLowerCase();
            user['maritalstatus'] = user['maritalstatus'].toLowerCase();
            user['country'] = user['country'].toUpperCase();

            let validatedUser = this.validateUser(user);
            if (validatedUser.valid) {
              let bd = moment(user.birthdate);
              let es = moment(user.employmentstart);
              let ed = moment(user.employmentend);

              bd = bd.isValid() ? bd : bd = moment(user.birthdate, 'D/M/YYYY');
              es = es.isValid() ? es : es = moment(user.employmentstart, 'D/M/YYYY');
              ed = ed.isValid() ? ed : ed = moment(user.employmentend, 'D/M/YYYY');

              user.birthdate = bd.isValid() ? bd.format('YYYY-MM-DD') : null;
              user.employmentstart = es.isValid() ? es.format('YYYY-MM-DD') : null;
              user.employmentend = ed.isValid() ? ed.format('YYYY-MM-DD') : null;
              user.password = this.randomPassword();
              user.fullname = user.firstname + ' ' + user.lastname;
              user.username = user.email;
              user.rowIndex = rowIndex + 1;
              users.push(user)
            } else {
              this.invalidRows.push(validatedUser.user)
            }
          }
        }

      });
      this.results = users;
    },
    resetFileInput() {
      // console.log('input handler')
    },
    readFile(evt) {
      let files = null;
      // this.filename = '';
      // this.reader = new FileReader();
      // this.reader.onload = (e) => {
      //   this.parseFile(e)
      // };

      files = evt.target.files;
      // console.log('readfile',files)
      this.filename = files[0].name;
      this.reader.readAsText(files[0]);
      evt.target.value = ''
    }
  }
}
</script>
<style>
@keyframes loadfade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes loadfade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.loadfade-enter-active {
  animation: loadfade-in 0s ease-out forwards;
  animation-delay: 0s;
}

.loadfade-leave-active {
  animation: loadfade-out .5s ease-out forwards;
  animation-delay: 1s;
}

</style>



// WEBPACK FOOTER //
// src/components/Users/UserImport.vue